export const iosAppDownloadLink = "https://apps.apple.com/ru/app/reclaim-verifier/id6503247508?l=en-GB";

export const androidAppDownloadLink =
  "https://play.google.com/store/apps/details?id=org.reclaimprotocol.app&hl=en";

export const reclaimMobileAppUrIScheme = "reclaim";

export const reclaimProtocolMobileAppUrIScheme = "reclaimprotocol";

export const reclaimVerifierMobileAppUrIScheme = "reclaimverifier";

export const THREE_JAN_APP_ID = "0x0d0dd13e8dc1cb552b59da371f433ff4fa64ecf7";
